/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskSpan = {
  /**
   * End byte position within the message content.
   */
  endPos?: number | undefined;
  /**
   * The message field this span matched, in author-facing form (content, prompt, assistant, tool_result, or tool.name/tool.server/tool.function/tool.args). Empty for detectors that don't attribute a field (e.g. gitleaks, presidio).
   */
  field?: string | undefined;
  /**
   * The matched secret or sensitive data for this span.
   */
  match: string;
  /**
   * The JSON sub-path within the field for a `.get(...)` match (e.g. 'command', 'payload.sql'). Empty when the whole field value matched.
   */
  path?: string | undefined;
  /**
   * Start byte position within the message content.
   */
  startPos?: number | undefined;
};

/** @internal */
export const RiskSpan$inboundSchema: z.ZodMiniType<RiskSpan, unknown> = z.pipe(
  z.object({
    end_pos: z.optional(z.int()),
    field: z.optional(z.string()),
    match: z.string(),
    path: z.optional(z.string()),
    start_pos: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "end_pos": "endPos",
      "start_pos": "startPos",
    });
  }),
);

export function riskSpanFromJSON(
  jsonString: string,
): SafeParseResult<RiskSpan, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskSpan$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskSpan' from JSON`,
  );
}
